/**
 * Mapping for translation keys.
 */
export const KEYS = {
  GRID: {
    DELETE_DEFINITION_QUESTION: 'Das folgende Zusatzfeld wirklich löschen?',
    DELETE_DEFINITION_WARNING: 'Achtung: Wenn dieses Feld bereits in Fragebögen verwendet wird, kann es zu Fehlern im Editor und bei der Ausfüllung kommen!',
    SUCCESSFULLY_DELETED_DEFINITION: 'Das Zusatzfeld wurde erfolgreich gelöscht.',
    ERROR_DELETING_DEFINITION: 'Beim Löschen des Zusatzfeldes ist ein Fehler aufgetreten.',
    ERROR_LOADING_DEFINITIONS: 'Beim Laden der Zusatzfelder ist ein Fehler aufgetreten.',
    CUSTOM_FIELDS: 'Zusatzfelder',
    SEARCH: 'Suche',
    ID: 'Id',
    KEY: 'Feldname',
    LABEL: 'Anzeigename',
    TYPE: 'Typ',
    REQUIRED: 'Pflicht',
    OPTIONS: 'Optionen',
    CREATED_AT: 'Erstellt am',
    UPDATED_AT: 'Bearbeitet am',
    ACTIONS: 'Aktionen',
    CHANGE: 'Bearbeiten',
    DELETE: 'Löschen',
    ENTRIES: 'Einträge',
    CREATE: 'Erstellen'
  },
  CRUD: {
    CUSTOM_FIELD: 'Zusatzfeld',
    SAVE: 'Speichern',
    CANCEL: 'Abbrechen',
    KEY: 'Feldname',
    ENTER_KEY: 'Feldname eingeben (z.B. smcb)',
    LABEL: 'Anzeigename',
    ENTER_LABEL: 'Anzeigename eingeben (z.B. SMC-B Kartennummer)',
    TYPE: 'Typ',
    SELECT_TYPE: 'Typ auswählen',
    TYPE_TEXT: 'Text',
    TYPE_NUMBER: 'Zahl',
    TYPE_DATE: 'Datum',
    TYPE_SELECT: 'Dropdown',
    TYPE_BOOLEAN: 'Checkbox',
    OPTIONS: 'Optionen',
    OPTION_VALUE: 'Option eingeben',
    ADD_OPTION: 'Option hinzufügen',
    REMOVE_OPTION: 'Option entfernen',
    ERROR_SAVING_DEFINITION: 'Beim Speichern des Zusatzfeldes ist ein Fehler aufgetreten',
    FOUND_NO_DEFINITION_BY_ID: 'Es wurde kein Zusatzfeld mit folgender Id gefunden:',
    SUCCESSFULLY_SAVED_DEFINITION: 'Das Zusatzfeld wurde erfolgreich gespeichert',
    KEY_NOT_EDITABLE: 'Der Feldname kann nach dem Erstellen nicht mehr geändert werden',
    KEY_INVALID_HINT: 'Der Feldname muss mit einem Buchstaben beginnen und darf nur Buchstaben, Ziffern und Unterstriche enthalten (max. 64 Zeichen)',
    VALIDATION: 'Validierung',
    REGULAR_EXPRESSION: 'Regulärer Ausdruck',
    REGEX_MODIFIER: 'Mod.',
    HINT: 'Hinweis',
    INVALID_REGEX: 'Ungültiger regulärer Ausdruck',
    REQUIRED_FIELD: 'Pflichtfeld',
    // standard field labels (for master data layout editor)
    GENDER: 'Geschlecht',
    MALE: 'Männlich',
    FEMALE: 'Weiblich',
    DIVERSE: 'Divers',
    FIRSTNAME: 'Vorname',
    LASTNAME: 'Nachname',
    BIRTHDATE: 'Geburtsdatum',
    ZIP_CODE: 'PLZ',
    CITY: 'Ort',
    STREET: 'Straße',
    STREET_NR: 'Hausnummer',
    ADDRESS_DEPRECATED: 'Adresse (veraltet)',
    EMAIL: 'E-Mail',
    LOCATION: 'Standort',
    PSEUDO_ID: 'Pseudo Id',
    ID: 'Patientennummer',
    CASE_NUMBER: 'Fallnummer',
    STATUS: 'Status',
    LANGUAGE: 'Sprache',
    ALLOW_MAIL_OPTION: 'E-Mail Option',
    PREFILL: 'Vorausfüllen',
    YES: 'Ja',
    NO: 'Nein',
    OPTIONAL: 'Optional',
    ENTER_FIRSTNAME: 'Bitte Vorname eingeben...',
    ENTER_LASTNAME: 'Bitte Nachname eingeben...',
    ENTER_LOCATION: 'Bitte Standort eingeben...',
    ENTER_PSEUDO_ID: 'Bitte Pseudo Id eingeben...',
    ENTER_PATIENT_ID: 'Bitte Patientennummer eingeben...',
    ENTER_CASE_NUMBER: 'Bitte Fallnummer eingeben...',
    ENTER_STATUS: 'Bitte Status eingeben...'
  },
  LAYOUT: {
    TITLE: 'Layout Editor',
    GRID_SIZE: 'Grid-Größe',
    AVAILABLE_FIELDS: 'Verfügbare Felder',
    ALL_PLACED: 'Alle Felder wurden platziert',
    RESET: 'Zurücksetzen',
    REMOVE: 'Entfernen',
    HINT: 'Ziehen Sie die Felder per Drag & Drop auf das Grid. Die Größe kann durch Ziehen an der unteren rechten Ecke angepasst werden.'
  },
  MASTER_DATA: {
    TITLE: 'Stammdaten',
    SUBTITLE: 'Legen Sie fest, welche Felder das Patientenformular enthält und wie sie angeordnet sind.',
    FORM: 'Patientenformular',
    RESIZE: 'Größe ändern',
    EDIT_MODE: 'Bearbeiten',
    PREVIEW: 'Vorschau',
    PREVIEW_HINT: 'So sieht das Patientenformular mit dem aktuellen Layout aus, auch mit noch nicht gespeicherten Änderungen. Eingaben in der Vorschau werden nicht gespeichert.',
    PREVIEW_DEFAULT: 'Es sind noch keine Felder platziert, das Patientenformular verwendet daher das Standard-Layout.',
    CHOOSE: 'Bitte auswählen...',
    DEFAULT_LANGUAGE: 'Deutsch',
    LAYOUT_EDITOR: 'Layout Editor',
    GRID_SIZE: 'Grid-Größe',
    AVAILABLE_FIELDS: 'Verfügbare Felder',
    SEARCH_FIELDS: 'Felder suchen...',
    NO_SEARCH_RESULTS: 'Keine Treffer',
    FORM_LAYOUT: 'Formular Grid',
    STANDARD_FIELDS: 'Stammdaten',
    CUSTOM_FIELDS: 'Zusatzfelder',
    ELEMENTS: 'Elemente',
    HR_DIVIDER: 'Trennlinie',
    ALL_STANDARD_PLACED: 'Alle Stammdaten wurden platziert',
    ALL_CUSTOM_PLACED: 'Alle Zusatzfelder wurden platziert',
    NO_CUSTOM_FIELDS: 'Keine Zusatzfelder definiert',
    SAVE: 'Speichern',
    SAVE_SUCCESS: 'Layout erfolgreich gespeichert',
    UNSAVED_CHANGES: 'Ungespeicherte Änderungen',
    RESET: 'Zurücksetzen',
    LOAD_DEFAULT: 'Standard Layout laden',
    REMOVE: 'Entfernen',
    HINT: 'Ziehen Sie die Felder per Drag & Drop auf das Grid. Platzierte Felder lassen sich verschieben, die Größe ändern Sie an der unteren rechten Ecke. Trennlinien können mehrfach platziert werden.'
  },
  GRID_RENDERER: {
    TITLE: 'Tabellenspalte',
    SUBTITLE: 'Legen Sie fest, wie Patienten in der Patientenliste angezeigt werden.',
    PREVIEW_COLUMN: 'Patient',
    REORDER: 'Ziehen zum Sortieren',
    HINT: 'Konfigurieren Sie hier, welche Daten in der Tabellenspalte angezeigt werden. Das Anzeige-Feld wird farbig hervorgehoben, die Detail-Zeile erscheint darunter als Zusatzinformation.',
    AVAILABLE_FIELDS: 'Verfügbare Felder',
    SEARCH_FIELDS: 'Felder suchen...',
    NO_SEARCH_RESULTS: 'Keine Treffer',
    STANDARD_FIELDS: 'Stammdaten',
    CUSTOM_FIELDS: 'Zusatzfelder',
    ALL_STANDARD_PLACED: 'Alle Stammdaten wurden platziert',
    ALL_CUSTOM_PLACED: 'Alle Zusatzfelder wurden platziert',
    NO_CUSTOM_FIELDS: 'Keine Zusatzfelder definiert',
    DISPLAY_FIELD: 'Anzeige-Feld',
    DISPLAY_FIELD_SHORT: 'Anzeige',
    DISPLAY_FIELD_DESC: 'Felder die im hervorgehobenen Bereich angezeigt werden.',
    DETAIL_LINE: 'Detail-Zeile',
    DETAIL_LINE_SHORT: 'Detail',
    DETAIL_LINE_DESC: 'Zusätzliche Informationen unterhalb des Anzeige-Felds.',
    ADD_TO_DISPLAY: 'Zum Anzeige-Feld hinzufügen',
    ADD_TO_DETAIL: 'Zur Detail-Zeile hinzufügen',
    LABEL_PLACEHOLDER: 'Label...',
    DROP_HINT: 'Felder über die Buttons links hinzufügen',
    PREVIEW: 'Vorschau',
    SAVE: 'Speichern',
    SAVE_SUCCESS: 'Konfiguration erfolgreich gespeichert',
    UNSAVED_CHANGES: 'Ungespeicherte Änderungen',
    RESET: 'Zurücksetzen',
    LOAD_DEFAULT: 'Standard laden',
    REMOVE: 'Entfernen'
  }
};

